// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"554":"2d989fc2","787":"5356182a"}[chunkId] + ".chunk.js";
};